import { fromJS } from 'immutable';

import {
  SET_CLAIM_TO_PREOPEN,
  RESET_PREOPEN_CLAIM,
  SET_CLAIM_ID,
  SET_IS_PROVISIONAL_CLAIM_EXIST,
} from 'containers/PreOpeningPage/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';

export interface ClaimAction {
  type: string;
  claim: any;
  isProvisionalClaimExist: {
    isProvisionalClaimExist: boolean | null;
  };
}

const initialState: any = fromJS({
  claim: {},
  claimId: null,
  isProvisionalClaimExist: null,
});

const toPreopenReducer = (state = initialState, action: ClaimAction) => {
  switch (action.type) {
    case SET_CLAIM_TO_PREOPEN:
      return state.set('claim', fromJS(action.claim));
    case SET_CLAIM_ID:
      return state.set('claimId', fromJS(action.claim));
    case RESET_PREOPEN_CLAIM:
      return state.set('claim', fromJS({}));
    case SET_IS_PROVISIONAL_CLAIM_EXIST:
      return state.set(
        'isProvisionalClaimExist',
        fromJS(action.isProvisionalClaimExist.isProvisionalClaimExist),
      );
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default toPreopenReducer;
